import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.salesrep/territory-manager/zipcode/picker/zipcode-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import ZipcodeParser from "emun.salesrep/territory-manager/zipcode/parser/zipcode-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class ZipcodePickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setZipcodeIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `zipcode-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setZipcodeIds();
	}
	clearAll() {
		this.selected = {};
		this.setZipcodeIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(zipcode) {
		return !!this.selected[zipcode.id];
	}

	setZipcodeIds() {
		this.zipcodeIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { zipcodeIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(zipcode) {
		const $ctrl = this;
		console.log("toggle", zipcode.id, $ctrl.selected, zipcode);

		if ($ctrl.single) {
			$ctrl.$close(zipcode);
		} else if (zipcode.id in $ctrl.selected) {
			delete $ctrl.selected[zipcode.id];
			$ctrl.onZipcodeUnSelected &&
				$ctrl.onZipcodeUnSelected({ $zipcode: zipcode, ...$ctrl });
		} else {
			$ctrl.selected[zipcode.id] = true;
			$ctrl.onZipcodeSelected &&
				$ctrl.onZipcodeSelected({ $zipcode: zipcode, ...$ctrl });
		}
		this.setZipcodeIds();
	}
	select(zipcode) {
		const $ctrl = this;
		$ctrl.$close([zipcode]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	parseZipcodes() {
		const $ctrl = this;
		ZipcodeParser({}).then(zipcodeIds => {
			$ctrl.selected = {};
			zipcodeIds.forEach(zipcodeId => {
				$ctrl.toggle({ id: zipcodeId });
			});
			$ctrl.viewSelections = true;
			$ctrl.viewSelectionsChanged();
		});
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryZipcodes.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"Id": "Zipcode: 1 to 9",
				"-Id": "Zipcode: 9 to 1"
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Id",
			autoLoad: true,
			append: false
		};
	}
}


